var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showActionbar)?_c('div',{ref:"actionbar",staticClass:"action-bar d-flex flex-row justify-content-between"},_vm._l((_vm.buttons),function(button,index){return _c('button',{key:index,staticClass:"btn",class:button.classes,on:{"click":button.handler}},[_vm._v(" "+_vm._s(button.label)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }